"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/accountLoginLog/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      url: '/protected/accountLoginLog/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};